'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _keys = require('babel-runtime/core-js/object/keys');

var _keys2 = _interopRequireDefault(_keys);

var _promise = require('babel-runtime/core-js/promise');

var _promise2 = _interopRequireDefault(_promise);

var _classCallCheck2 = require('babel-runtime/helpers/classCallCheck');

var _classCallCheck3 = _interopRequireDefault(_classCallCheck2);

var _createClass2 = require('babel-runtime/helpers/createClass');

var _createClass3 = _interopRequireDefault(_createClass2);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var DEFAULT_WATERMARK_DATA = {
  position: 9,
  size: 40,
  opacity: 40,
  imageUrl: '8bb438_9ad16b69fd1b4ab29324f97f1323b05a~mv2.png',
  imageRatio: 1.42517815
};

var WatermarkHelper = function () {
  function WatermarkHelper() {
    (0, _classCallCheck3.default)(this, WatermarkHelper);

    this.watermark = DEFAULT_WATERMARK_DATA;
    this.watermarkApi;
    this.watermarkWasSet = false;

    this.init();
  }

  (0, _createClass3.default)(WatermarkHelper, [{
    key: 'init',
    value: function init() {
      var _this = this;

      try {
        if (!this.watermarkWasSet && this.isStoreIframe) {
          new _promise2.default(function (resolve) {
            require.ensure([], function (require) {
              resolve(require( /* webpackChunkName: "watermarkApi" */'./watermarkApi'));
            });
          }).then(function (module) {
            var watermarkApi = module.default;
            watermarkApi.getWatermarkData().then(function (data) {
              if (!_this.watermarkWasSet) {
                _this.setWatermark(data);
              }
            });
          });
        }
      } catch (e) {
        console.error('Cannot get watermark', e); //eslint-disable-line
      }
    }
  }, {
    key: 'isValid',
    value: function isValid(watermark) {
      return !!watermark && typeof watermark.position !== 'undefined' && typeof watermark.size !== 'undefined' && typeof watermark.opacity !== 'undefined' && typeof watermark.imageUrl !== 'undefined' && typeof watermark.imageRatio !== 'undefined';
    }
  }, {
    key: 'setWatermark',
    value: function setWatermark(watermark) {
      if (this.isValid(watermark)) {
        this.watermark = watermark;
        this.watermarkWasSet = true;
      }
    }
  }, {
    key: 'isStoreIframe',
    get: function get() {
      //allow watermark in art-store only
      if (typeof this.isStore === 'undefined') {
        try {
          this.isStore = window.location.search.toLowerCase().indexOf('isstore') > -1;
        } catch (e) {
          this.isStore = undefined;
          return false;
        }
      }
      return this.isStore;
    }
  }, {
    key: 'exists',
    get: function get() {
      return this.watermarkWasSet && (0, _keys2.default)(this.watermark).length > 0;
    }
  }, {
    key: 'obj',
    get: function get() {
      return this.watermark;
    }
  }, {
    key: 'str',
    get: function get() {
      return this.exists ? this.watermark.imageUrl + '-' + this.watermark.opacity + '-' + this.watermark.position + '-' + this.watermark.size : '';
    }
  }, {
    key: 'strUrl',
    get: function get() {
      return this.exists ? ',wm_' + this.str : '';
    }
  }]);
  return WatermarkHelper;
}();

exports.default = new WatermarkHelper();